import React, { useState } from 'react';
import './Navbar.css';
import { SettingsType } from '../interfaces/SettingsType';

interface NavbarProps {
  onNavigate: (page: string) => void;
  currentPage: string;
  settings: SettingsType | undefined;
}

const screenConfig = [
  { name: 'Startseite', slug: '/' },
  { name: 'DJI Matrice 350', slug: '/droneM350' },
  { name: 'DJI Mavic 2EA', slug: '/droneM2EA' },
  { name: 'Pilot', slug: '/pilot' },
  { name: 'Wartung', slug: '/maintenance' },
  { name: 'Einstellungen', slug: '/settings', onlyAdmin: true },
  { name: 'Abmelden', slug: '/logout' },
];

const Navbar: React.FC<NavbarProps> = ({
  onNavigate,
  currentPage,
  settings,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const closeNavbar = () => {
    setIsOpen(false);
  };

  const currentScreen = screenConfig.find((item) => item.slug === currentPage);
  const currentTitle = currentScreen ? currentScreen.name : 'Titel';

  return (
    <>
      <header className="topbar">
        <h1 className="topbar-title">{currentTitle}</h1>
      </header>

      <nav className={`navbar ${isOpen ? 'open' : ''}`}>
        <div className="logo-container">
          <img src="/img/logo_black.svg" alt="Logo" className="logo" />
        </div>
        <ul>
          {screenConfig.map((item) => (
            <>
              {(item.onlyAdmin == undefined ||
                (settings && settings.isAdmin) ||
                true) && (
                <li
                  key={item.slug}
                  className={currentPage === item.slug ? 'active' : ''}
                >
                  <button
                    onClick={() => {
                      onNavigate(item.slug);
                      closeNavbar();
                    }}
                  >
                    {item.name}
                  </button>
                </li>
              )}
            </>
          ))}
        </ul>
      </nav>
      <button className="mobile-toggle" onClick={toggleNavbar}>
        ☰
      </button>
      {isOpen && <div className="overlay" onClick={closeNavbar}></div>}
    </>
  );
};

export default Navbar;
